export default "__VITE_ASSET__CCyqQNt1__"